/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Person } from './Person';
import {
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
} from './Person';

/**
 * 
 * @export
 * @interface TeamDetails
 */
export interface TeamDetails {
    /**
     * 
     * @type {string}
     * @memberof TeamDetails
     */
    homeColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamDetails
     */
    visitorColor?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamDetails
     */
    goalkeepColor?: string;
    /**
     * 
     * @type {Person}
     * @memberof TeamDetails
     */
    responsiblePerson?: Person;
    /**
     * 
     * @type {string}
     * @memberof TeamDetails
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamDetails
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamDetails
     */
    city?: string;
}

/**
 * Check if a given object implements the TeamDetails interface.
 */
export function instanceOfTeamDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TeamDetailsFromJSON(json: any): TeamDetails {
    return TeamDetailsFromJSONTyped(json, false);
}

export function TeamDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'homeColor': !exists(json, 'home_color') ? undefined : json['home_color'],
        'visitorColor': !exists(json, 'visitor_color') ? undefined : json['visitor_color'],
        'goalkeepColor': !exists(json, 'goalkeep_color') ? undefined : json['goalkeep_color'],
        'responsiblePerson': !exists(json, 'responsible_person') ? undefined : PersonFromJSON(json['responsible_person']),
        'country': !exists(json, 'country') ? undefined : json['country'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'city': !exists(json, 'city') ? undefined : json['city'],
    };
}

export function TeamDetailsToJSON(value?: TeamDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'home_color': value.homeColor,
        'visitor_color': value.visitorColor,
        'goalkeep_color': value.goalkeepColor,
        'responsible_person': PersonToJSON(value.responsiblePerson),
        'country': value.country,
        'state': value.state,
        'city': value.city,
    };
}

